import { createAsyncThunk } from '@reduxjs/toolkit';
import { Dispatch, SetStateAction } from 'react';
import { RootState } from '../../app/store';
import { ErrorToast } from '../../components';
import { setUserToLS } from '../../helpers/localstorage-helper';
import { changeAvailableLoyaltyPoints } from '../../slices/auth-slice';
import {
  buyDiscountCodeAsync,
  getDiscountCodesAsync,
  getSearchedUnilevelUsersAsync
} from './DiscountCode.requests';
import { BuyDiscountCodeSteps } from './DiscountCode.types';

export const getDiscountCodes = createAsyncThunk(
  'getDiscountCodes',
  async () => {
    const { data } = await getDiscountCodesAsync();

    return data!.discountCodes;
  }
);

// export const getSearchedUnilevelUsers = createAsyncThunk(
//   'getDiscountCodes',
//   async ({ searchTerm }: any) => {
//     let query = '';
//     if (isNaN(searchTerm)) {
//       query = `?username=${searchTerm}`;
//     } else {
//       query = `?userId=${searchTerm}`;
//     }

//     const { data } = await getSearchedUnilevelUsersAsync({ query });

//     return data!.users;
//   }
// );

export const buyDiscountCode = createAsyncThunk(
  'buyDiscountCode',
  async (
    {
      discountCodeId,
      receiverUserId,
      setStep
    }: {
      discountCodeId: number;
      receiverUserId: number;
      setStep: Dispatch<SetStateAction<number>>;
    },
    { dispatch, getState }
  ) => {
    try {
      const { data } = await buyDiscountCodeAsync({
        discountCodeId,
        receiverUserId
      });

      const state = getState() as RootState;

      setStep(BuyDiscountCodeSteps.SUCCESS);

      dispatch(changeAvailableLoyaltyPoints(data!.userTickets.loyaltyPoints));

      const user = {
        ...state.auth.userInfo,
        user: {
          ...state.auth.userInfo.user,
          userTickets: data!.userTickets
        }
      };

      setUserToLS(user);

      return null;
    } catch (error: any) {
      ErrorToast(error.response.data.error);
    }
  }
);
